import { type Theme } from "@mui/material";

import { type MuiThemeComponentOverride } from "./types";

export function getMuiSwitch(_theme: Theme): MuiThemeComponentOverride<"MuiSwitch"> {
  return {
    MuiSwitch: {
      defaultProps: {
        color: "secondary",
      },
    },
  };
}
